(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6326],{

/***/ 42540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(50029);
/* harmony import */ var _material_ui_core_Container__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(50253);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(22318);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91315);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1438);
/* harmony import */ var components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92208);
/* harmony import */ var components_Icons_PaymentWhatsappIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66473);
/* harmony import */ var components_Icons_TelegramIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57310);
/* harmony import */ var components_PurchasePage_PurchaseContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33574);
/* harmony import */ var components_QuickPurchasePage_QuickPurchaseContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98968);
/* harmony import */ var components_Reusable_Bit_NextLink__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16110);
/* harmony import */ var components_Reusable_Functions_Functions__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(64416);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(50066);
/* harmony import */ var _public_animation_Conffeti_json__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5081);
/* harmony import */ var _public_animation_Purchase_successful_json__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79412);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85893);






















var Lottie = next_dynamic__WEBPACK_IMPORTED_MODULE_9___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9260)]).then(__webpack_require__.t.bind(__webpack_require__, 69260, 23));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(69260)];
    }
  }
});
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SuccessPage__StyledWrapper",
  componentId: "sc-b9uzxy-0"
})(["background-size:cover;background-repeat:no-repeat;display:flex;justify-content:center;align-items:center;position:", ";", "{width:", ";height:", ";svg{transform:", ";}}", "{height:", ";margin-top:80px;top:", ";}"], function (p) {
  return p.$conffeti ? "absolute" : "initial";
}, function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return !p.$conffeti && (p.$isGroupPurchase ? "405px" : "450px");
}, function (p) {
  return p.$conffeti ? "auto" : "275px";
}, function (p) {
  return p.$conffeti ? " scale(1) !important;" : "scale(1.5) !important;";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.$isGroupPurchase ? "250px" : "300px";
}, function (p) {
  return p.$conffeti && 0;
});
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z).attrs({
  variant: "h1"
}).withConfig({
  displayName: "SuccessPage__StyledTitle",
  componentId: "sc-b9uzxy-1"
})(["color:", ";font-size:50px;", "{font-size:40px;line-height:0.8;margin-bottom:5px;}"], function (p) {
  return p.theme.colors.black;
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SuccessPage__StyledButtonWrapper",
  componentId: "sc-b9uzxy-2"
})(["display:flex;justify-content:flex-start;margin-bottom:40px;"]);
var StyledGenericButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
  displayName: "SuccessPage__StyledGenericButton",
  componentId: "sc-b9uzxy-3"
})(["margin-top:", ";", "{margin-top:", ";}"], function (p) {
  return p.$isGroupPurchase ? "44px" : "40px";
}, function (p) {
  return p.theme.breakpoints.up("sm");
}, function (p) {
  return p.$isGroupPurchase ? "40px" : "26px";
});
var StyledBoxWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z).withConfig({
  displayName: "SuccessPage__StyledBoxWrapper",
  componentId: "sc-b9uzxy-4"
})(["display:flex;flex-direction:column;align-items:center;position:relative;z-index:99;margin-bottom:", ";top:-30px;", "{display:flex;flex-direction:column;align-items:", ";margin-right:", ";margin-bottom:", ";top:0;}"], function (p) {
  return p.$isGroupPurchase ? "30px" : "0px";
}, function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.$isGroupPurchase ? "center" : "start";
}, function (p) {
  return p.$isGroupPurchase ? "0px" : "70px";
}, function (p) {
  return p.$isGroupPurchase ? "40px" : "0px";
});
var StyledBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(_material_ui_core_Container__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z).withConfig({
  displayName: "SuccessPage__StyledBox",
  componentId: "sc-b9uzxy-5"
})(["", "{display:flex;flex-direction:", ";flex-grow:1;align-items:center;justify-content:center;margin-top:120px;}"], function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.$isGroupPurchase ? "column" : "row";
});
var StyledLottie = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Lottie).withConfig({
  displayName: "SuccessPage__StyledLottie",
  componentId: "sc-b9uzxy-6"
})(["position:relative;z-index:-1;"]);
var defaultText = "\n  color: var(--Black, var(--Primary-Black, #000));\n  text-align: right;\n  font-family: Speedee, NarkisBlock;\n\n  line-height: normal;\n  margin: 0;\n  padding: 0;\n";
var StyledBody = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SuccessPage__StyledBody",
  componentId: "sc-b9uzxy-7"
})(["", " width:100%;margin-top:8px;font-size:24px;font-weight:normal;text-align:center;margin-bottom:14px;", "{text-align:right;text-align:right;}"], defaultText, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledSocialTitle = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "SuccessPage__StyledSocialTitle",
  componentId: "sc-b9uzxy-8"
})(["", " width:100%;text-align:center;font-size:26px;margin-bottom:11px;font-weight:bold;", "{text-align:right;margin-top:16px;display:block;}"], defaultText, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledIconsWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z).withConfig({
  displayName: "SuccessPage__StyledIconsWrapper",
  componentId: "sc-b9uzxy-9"
})(["display:flex;flex-direction:column;position:relative;z-index:9;"]);
var StyledSvgDiv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SuccessPage__StyledSvgDiv",
  componentId: "sc-b9uzxy-10"
})(["display:flex;align-items:center;justify-content:start;gap:16px;", "{justify-content:center;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledSvgWrapper = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SuccessPage__StyledSvgWrapper",
  componentId: "sc-b9uzxy-11"
})(["cursor:pointer;display:flex;justify-content:center;align-items:center;svg{cursor:pointer;}"]);
var StyledGiftcardLottie = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Lottie).withConfig({
  displayName: "SuccessPage__StyledGiftcardLottie",
  componentId: "sc-b9uzxy-12"
})([""]);

var SuccessPayment = function SuccessPayment() {
  var _useQuickPurchaseCont = (0,components_QuickPurchasePage_QuickPurchaseContext__WEBPACK_IMPORTED_MODULE_7__/* .useQuickPurchaseContext */ .Nr)(),
      quickPurchaseInputValues = _useQuickPurchaseCont.quickPurchaseInputValues,
      setQuickPurchaseInputValues = _useQuickPurchaseCont.setQuickPurchaseInputValues,
      setGiftCardPrice = _useQuickPurchaseCont.setGiftCardPrice;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(""),
      text = _useState[0],
      setText = _useState[1];

  var RecipientName = (0,react__WEBPACK_IMPORTED_MODULE_11__.useRef)(quickPurchaseInputValues === null || quickPurchaseInputValues === void 0 ? void 0 : quickPurchaseInputValues.RecipientName);

  var _usePurchaseContext = (0,components_PurchasePage_PurchaseContext__WEBPACK_IMPORTED_MODULE_6__/* .usePurchaseContext */ .AX)(),
      orderRecipientGuid = _usePurchaseContext.orderRecipientGuid,
      groupPurchaseGuid = _usePurchaseContext.groupPurchaseGuid;

  (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function () {
    // Clear the cache
    setQuickPurchaseInputValues(components_QuickPurchasePage_QuickPurchaseContext__WEBPACK_IMPORTED_MODULE_7__/* .initialState */ .E3);
    setGiftCardPrice(0); // If user hasn't gone through process, send them back to the start

    if (!(quickPurchaseInputValues !== null && quickPurchaseInputValues !== void 0 && quickPurchaseInputValues.RecipientName)) router.push("/quick-purchase");
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function () {
    if (orderRecipientGuid) {
      var getData = /*#__PURE__*/function () {
        var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
          var _yield$getOrderGetOrd, data;

          return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return (0,api__WEBPACK_IMPORTED_MODULE_1__.getOrderGetOrderGiftCardSharingText)(orderRecipientGuid, groupPurchaseGuid);

                case 2:
                  _yield$getOrderGetOrd = _context.sent;
                  data = _yield$getOrderGetOrd.data;
                  setText(data.body);

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function getData() {
          return _ref.apply(this, arguments);
        };
      }();

      getData();
    }
  }, [orderRecipientGuid]);
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_11__.useRef)(null);
  var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .useIsDesktop */ .Ce)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
  var isGroupPurchase = router.pathname.includes("groupPurchases");
  (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function () {
    if (document) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function () {
    var _ref$current;

    ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.setSpeed(0.8);
  }, [ref]);
  (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function () {
    !isGroupPurchase && (0,api__WEBPACK_IMPORTED_MODULE_1__.clearApiToken)();
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(StyledBox, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(StyledWrapper, {
      $conffeti: false,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(StyledGiftcardLottie, {
        animationData: _public_animation_Purchase_successful_json__WEBPACK_IMPORTED_MODULE_13__,
        lottieRef: ref,
        loop: false
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(StyledWrapper, {
      $conffeti: true,
      children: [isDesktop && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(StyledLottie, {
        animationData: _public_animation_Conffeti_json__WEBPACK_IMPORTED_MODULE_12__,
        loop: true
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(StyledLottie, {
        animationData: _public_animation_Conffeti_json__WEBPACK_IMPORTED_MODULE_12__,
        loop: true
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(StyledBoxWrapper, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(StyledTitle, {
        children: ["\u05D0\u05D9\u05D6\u05D4 \u05DB\u05D9\u05E3 \u05E9\u05D9\u05DE\u05D7\u05EA \u05D0\u05EA ", RecipientName.current || ""]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(StyledTitle, {
        children: "\u05D4\u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05E0\u05E9\u05DC\u05D7 \u05E2\u05DB\u05E9\u05D9\u05D5!"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(StyledBody, {
        children: "\u05D1\u05E8\u05D2\u05E2\u05D9\u05DD \u05D0\u05DC\u05D5 \u05D0\u05E0\u05D7\u05E0\u05D5 \u05E9\u05D5\u05DC\u05D7\u05D9\u05DD \u05E2\u05D3\u05DB\u05D5\u05DF \u05E2\u05DC \u05E7\u05D1\u05DC\u05EA \u05D4\u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05D1\u05D4\u05D5\u05D3\u05E2\u05D4"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(StyledIconsWrapper, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(StyledSocialTitle, {
          children: "\u05E9\u05EA\u05E4\u05D5 \u05D0\u05EA \u05D4\u05DE\u05EA\u05E0\u05D4 \u05E9\u05E8\u05DB\u05E9\u05EA\u05DD"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(StyledSvgDiv, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(StyledSvgWrapper, {
            onClick: function onClick() {
              return window.open(isDesktop ? (0,components_Reusable_Functions_Functions__WEBPACK_IMPORTED_MODULE_20__/* .shareSocialNetworkLinks */ .rB)(text).whatsapp.desktop : (0,components_Reusable_Functions_Functions__WEBPACK_IMPORTED_MODULE_20__/* .shareSocialNetworkLinks */ .rB)(text).whatsapp.mobile);
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(components_Icons_PaymentWhatsappIcon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(StyledSvgWrapper, {
            onClick: function onClick() {
              return window.open(isDesktop ? (0,components_Reusable_Functions_Functions__WEBPACK_IMPORTED_MODULE_20__/* .shareSocialNetworkLinks */ .rB)(text).telegram.desktop : (0,components_Reusable_Functions_Functions__WEBPACK_IMPORTED_MODULE_20__/* .shareSocialNetworkLinks */ .rB)(text).telegram.mobile);
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(components_Icons_TelegramIcon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(components_Reusable_Bit_NextLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        href: "/",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(StyledButtonWrapper, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(StyledGenericButton, {
            $isGroupPurchase: isGroupPurchase,
            btnType: "filled",
            width: 180,
            children: "\u05D7\u05D6\u05E8\u05D4 \u05DC\u05E2\u05DE\u05D5\u05D3 \u05D4\u05D1\u05D9\u05EA"
          })
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SuccessPayment);

/***/ }),

/***/ 42109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PaymentSteps": function() { return /* binding */ PaymentSteps; }
/* harmony export */ });
/* harmony import */ var components_PurchasePage_Preview_Payment_BlockedPayment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63087);
/* harmony import */ var components_PurchasePage_Preview_Payment_FailedPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69045);
/* harmony import */ var components_PurchasePage_Preview_Payment_PaymentContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79625);
/* harmony import */ var components_PurchaseSummaryPage_PurchaseSummaryPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85776);
/* harmony import */ var components_Reusable_Loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83457);
/* harmony import */ var components_SuccessPage_SuccessPage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42540);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);










var ENV = "production";
var PaymentSteps;

(function (PaymentSteps) {
  PaymentSteps[PaymentSteps["PAYMENT"] = 1] = "PAYMENT";
  PaymentSteps[PaymentSteps["FAIL"] = 2] = "FAIL";
  PaymentSteps[PaymentSteps["SUCCESS"] = 3] = "SUCCESS";
  PaymentSteps[PaymentSteps["FAILURE"] = 4] = "FAILURE";
  PaymentSteps[PaymentSteps["LOADER"] = 5] = "LOADER";
  PaymentSteps[PaymentSteps["BLOCKED"] = 6] = "BLOCKED";
})(PaymentSteps || (PaymentSteps = {}));

var Payment = function Payment() {
  var _usePaymentContext = (0,components_PurchasePage_Preview_Payment_PaymentContext__WEBPACK_IMPORTED_MODULE_2__/* .usePaymentContext */ .JL)(),
      paymentSteps = _usePaymentContext.paymentSteps,
      setPaymentSteps = _usePaymentContext.setPaymentSteps,
      setIframeLink = _usePaymentContext.setIframeLink;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
      children: ENV !== "production" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("script", {
          src: "https://ppsuat.creditguard.co.il/plugins/applePayOnIframe.js"
        })
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("script", {
        src: "https://pps.creditguard.co.il/plugins/applePayOnIframe.js"
      })
    }), paymentSteps === PaymentSteps.PAYMENT && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_PurchaseSummaryPage_PurchaseSummaryPage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}), paymentSteps === PaymentSteps.FAIL && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_PurchasePage_Preview_Payment_FailedPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      title: "\u05D0\u05D5\u05D9.. \u05D7\u05D9\u05D5\u05D1 \u05D4\u05EA\u05E9\u05DC\u05D5\u05DD \u05E0\u05DB\u05E9\u05DC",
      text: "\u05E0\u05E8\u05D0\u05D4 \u05E9\u05D9\u05E9 \u05D1\u05E2\u05D9\u05D4 \u05D1\u05EA\u05E7\u05E9\u05D5\u05E8\u05EA \u05D0\u05D5 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D9 \u05D4\u05EA\u05E9\u05DC\u05D5\u05DD",
      link: "/payment",
      setPaymentSteps: setPaymentSteps,
      setIframeLink: setIframeLink
    }), paymentSteps === PaymentSteps.SUCCESS && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_SuccessPage_SuccessPage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}), paymentSteps === PaymentSteps.FAILURE && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_PurchasePage_Preview_Payment_FailedPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      title: "\u05D0\u05D5\u05E4\u05E1\u05D9, \u05DE\u05E9\u05D4\u05D5 \u05D4\u05E9\u05EA\u05D1\u05E9 \u05D1\u05D3\u05E8\u05DA",
      text: "\u05D0\u05DD \u05D4\u05D1\u05E2\u05D9\u05D4 \u05DE\u05DE\u05E9\u05D9\u05DB\u05D4 \u05D0\u05E4\u05E9\u05E8 \u05DC\u05E4\u05E0\u05D5\u05EA \u05DC\u05E9\u05D9\u05E8\u05D5\u05EA \u05DC\u05E7\u05D5\u05D7\u05D5\u05EA.",
      link: "/payment",
      setPaymentSteps: setPaymentSteps,
      setIframeLink: setIframeLink
    }), paymentSteps === PaymentSteps.LOADER && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_Reusable_Loader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}), paymentSteps === PaymentSteps.BLOCKED && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_PurchasePage_Preview_Payment_BlockedPayment__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {})]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Payment);

/***/ }),

/***/ 9817:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quick-purchase/payment",
      function () {
        return __webpack_require__(42109);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,2726,3450,2198,2663,3818,4055,1456,9904,8643,2563,3050,5776,9774,2888,179], function() { return __webpack_exec__(9817); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);